/**
 * Mapiranje ID-jeva pitanja i polja forme za predlog obaveze (konsenzus i CTA).
 */

/** ID-jevi pitanja u proposal flow-u. */
export const OBLIGATION_PROPOSAL_QUESTION_ID = Object.freeze({
  PROBLEM: 1,
  PROBLEM_CAUSES: 2,
  PREVIOUS_WORK: 3,
  SOLUTION: 4,
  EXPECTED_RESULTS: 5,
  ANALYSIS_TRANSPARENCY: 6,
  ANALYSIS_ACCOUNTABILITY: 7,
  ANALYSIS_PARTICIPATION: 8,
  HOW: 5,
  POU1: 8,
  POU2: 6,
  POU3: 7,
  POU4: 8,
});

/** Mapiranje ključa polja forme na ID pitanja. */
export const OBLIGATION_CONSENSUS_FIELD_TO_QUESTION_ID = Object.freeze({
  problem_definition: OBLIGATION_PROPOSAL_QUESTION_ID.PROBLEM,
  problem_causes: OBLIGATION_PROPOSAL_QUESTION_ID.PROBLEM_CAUSES,
  obligation_previous_work: OBLIGATION_PROPOSAL_QUESTION_ID.PREVIOUS_WORK,
  obligation_proposed_solution: OBLIGATION_PROPOSAL_QUESTION_ID.SOLUTION,
  obligation_expected_results: OBLIGATION_PROPOSAL_QUESTION_ID.EXPECTED_RESULTS,
  analysis_transparency: OBLIGATION_PROPOSAL_QUESTION_ID.ANALYSIS_TRANSPARENCY,
  analysis_accountability: OBLIGATION_PROPOSAL_QUESTION_ID.ANALYSIS_ACCOUNTABILITY,
  analysis_participation: OBLIGATION_PROPOSAL_QUESTION_ID.ANALYSIS_PARTICIPATION,
});

/**
 * Stari (FE-only) raspored ID-jeva pre prelaska na kanonski 1–8 (commit 85d933e, 2026-04-27).
 * Nikada nije koristio ID 7 ni 8; polja bez legacy pitanja su `null`.
 */
export const LEGACY_OBLIGATION_PROPOSAL_QUESTION_ID = Object.freeze({
  PROBLEM: 1,
  PROBLEM_CAUSES: null,
  PREVIOUS_WORK: null,
  SOLUTION: 2,
  EXPECTED_RESULTS: 3,
  ANALYSIS_PARTICIPATION: 4,
  ANALYSIS_TRANSPARENCY: 5,
  ANALYSIS_ACCOUNTABILITY: 6,
});

/** Odgovori kreirani od ovog trenutka su uvek u kanonskom (1–8) rasporedu. */
export const OBLIGATION_PROPOSAL_EXTENDED_MAPPING_SINCE = Date.parse('2026-04-27T00:00:00Z');
